/* Main File */
(function($) {

  'use strict';

  const BASE_API = $('[rel="https://api.w.org/"]').attr('href') + 'wp/v2';
  const BASE_URL = $('body').data('baseurl');
  var lastScrollTop = 0;

  function initMap(location) {
    let map = new google.maps.Map(document.getElementById('map'), {
      zoom: 16,
      disableDefaultUI: true,
      center: location,
      styles: [
        {
          "featureType": "all",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "saturation": 36
            },
            {
              "color": "#000000"
            },
            {
              "lightness": 40
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "visibility": "on"
            },
            {
              "color": "#000000"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "all",
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 17
            },
            {
              "weight": 1.2
            }
          ]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 20
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 21
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 17
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 29
            },
            {
              "weight": 0.2
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 18
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 16
            }
          ]
        },
        {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 19
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#000000"
            },
            {
              "lightness": 17
            }
          ]
        }
    ]
    });

    let marker = new google.maps.Marker({
      position: location,
      map: map
    });
  }

  function isMobile() {
    return $(window).width() < 1024;
  }

  function getPosition(element) {
    let bodyRect = document.body.getBoundingClientRect();
    let elementCover = element.firstElementChild;
    let elementCoverPosition = elementCover.getBoundingClientRect();

    return {
      width: elementCover.offsetWidth,
      height: elementCover.offsetHeight,
      x: elementCoverPosition.left - element.getBoundingClientRect().left,
      y: $(element).position().top
    }
  }

  function move(position) {
    let imageCover = document.querySelector('.image-cover');
    let inViewElement = document.querySelector('.project.inview');
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let offsetInview;
    let animationTime = (typeof position.type !== 'undefined' && position.type === 'resize') ? 0 : 0.5;

    if (inViewElement === null) {
      return;
    }

    if (scrollTop > lastScrollTop){
      offsetInview = $(window).height() / 2;
    } else {
      offsetInview = $(window).height() / 3;
    }

    lastScrollTop = scrollTop;

    inView.offset(offsetInview);

    if (!position.hasOwnProperty('width')) {
      position = getPosition(inViewElement);
    }

    TweenMax.to(imageCover, animationTime, {
      ease: Power1.easeInOut,
      width: position.width,
      height: position.height,
      x: position.x,
      top: position.y,
      onStart: function() {
        if (!inViewElement.classList.contains('is-active')) {
          TweenMax.to(imageCover, 0.5, { opacity: 1 });

          return false;
        }
      },
      onUpdate: function() {
      },
      onComplete: function() {
        if (!inViewElement.classList.contains('is-active')) {
          TweenMax.to(imageCover, 0.5, { opacity: 0.5, delay: 0.5 });
        }
        inViewElement.classList.add('is-active');
      }
    });
  }

  function moveWindow(element) {
    TweenMax.to(window, 1, {
      scrollTo: {
        y: $(element).offset().top - (isMobile() ? 80 : 150),
        autoKill: false
      },
      ease:Power3.easeOut
    });
  }

  function inview() {
    inView('.project, .work-image')
    .on('enter', el => {
      el.classList.add('inview');
    })
    .on('exit', el => {
      el.classList.remove('inview');
      el.classList.remove('is-active');
    });
  }

  function changeSectionBackground(el, color) {
    el.css('background-color', color );
  }

  window.addEventListener('scroll', move, false);
  window.addEventListener('resize', move, false);

  $(document).ready(function() {


    if ($('.about-services').length > 0) {
      let $target = $('.about-services');
      let firstTarget = $target.children().first();
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let offsetInview;

      changeSectionBackground($target, firstTarget.data('background'));

      if (scrollTop > lastScrollTop){
        offsetInview = $(window).height() / 2;
      } else {
        offsetInview = $(window).height() / 3;
      }

      lastScrollTop = scrollTop;

      inView.offset(offsetInview);

      inView('.about-service').on('enter', function(el){
        let color = $(el).attr('data-background');
        changeSectionBackground($target, color);
      });
    } else {
      inview();
    }

    $('.js-language-switcher').click(function() {
      $(this).toggleClass('is-opened');
    });

    $('.js-menu__trigger').click(function() {
      $('.page-header').toggleClass('is-opened');
      $('.main-menu ').toggleClass('is-opened');
    });

    $('.js-top').click(function(e) {
      e.preventDefault();
      $('html, body').stop().animate({
        scrollTop: 0
      }, 2000);
    });

    $('.form-control').on('focus', function() {
      $(this).parent().addClass('on-focus');
    });

    $('.form-control').on('blur', function() {
      if ($(this).val().trim().length === 0) {
        $(this).parent().removeClass('on-focus');
      }
    });

    $('.js-more-projects').click(function(event) {
      event.preventDefault();

      let loadMoreButton = $(this),
      loader = loadMoreButton.next(),
      pageNumber = loadMoreButton.data('page'),
      currentLang = $('html').attr('lang').slice(0, 2),
      projectContainer = $('.projects-inner'),
      size = 1;

      $.ajax({
        url: `${BASE_API}/works`,
        method: 'GET',
        dataType: 'json',
        data: {
          page: pageNumber + 1,
          size,
          lang: currentLang
        },
        beforeSend: function() {
          loader.addClass('is-active');
          loadMoreButton.addClass('disabled');
          loadMoreButton.prop('disabled', true);
        }
      })
      .done(function(response) {
        let output = '';

        for (let i = 0; i < response.works.length; i++) {
          output += `<div class="project project--${response.works[i].position}">
            <div class="project__image">
              <div class="project__image-background" style="background-image: url(${response.works[i].cover});"></div>
              <a href="${response.works[i].permalink}" class="project__image-link"></a>
            </div>
            <div class="project__info">
              <h3 class="project__info-name">${response.works[i].post_title}</h3>
              <div class="project__info-action">
                <a href="${response.works[i].permalink}" class="button button--white">${response.works[i].action_text}</a>
              </div>
            </div>
          </div>`;
        }

        projectContainer.append(output);
        let projects = document.querySelectorAll('.project');
        let lastProject = projects[projects.length - size];

        inview();
        moveWindow(lastProject);

        if (response.has_more) {
          loadMoreButton.data('page', pageNumber + 1);
        } else {
          loadMoreButton.fadeOut();
        }

      })
      .fail(function(error) {
        console.warn(error);
      })
      .always(function() {
        loader.removeClass('is-active');
        loadMoreButton.removeClass('disabled');
        loadMoreButton.prop('disabled', false);
      });

    });

    if ($('.js-rellax').length > 0) {
      new Rellax('.js-rellax', {
        speed: 2,
        center: true,
        round: true,
        vertical: true,
        horizontal: false
      });
    }

    if ($('body').hasClass('post-type-archive-works')) {
      let firstProject = document.querySelectorAll('.project')[0];
      firstProject.classList.add('inview');
      move(getPosition(firstProject));
    }

    if ($('#map').length > 0) {
      let coordinates = {
        lat: parseFloat($('#map').data('lat')),
        lng: parseFloat($('#map').data('lng'))
      };

      initMap(coordinates);
    }

    $('.form').submit(function(event) {
      event.preventDefault();

      let form = this,
      $form = $(form),
      submitButton = $form.find('button[type="submit"]'),
      loader = submitButton.next(),
      responseBox = $form.find('.form-response'),
      data = $form.serialize();

      // At last one job checklist selected
      if ($('input[name="job[]"]').length > 1 && $('input[name="job[]"]:checked').length === 0) {
        data = data + "&job%5B%5D";
      }

      if ($('input[name="find_us"]').length > 1 && $('input[name="find_us"]:checked').length === 0) {
        data = data + "&find_us=";
      }

      $.ajax({
        url: `${BASE_URL}/wp-admin/admin-ajax.php`,
        method: 'POST',
        dataType: 'json',
        data,
        beforeSend: function() {
          loader.addClass('is-active');
          submitButton.addClass('disabled');
          submitButton.prop('disabled', true);
        }
      })
      .done(function(response) {
        const { status, message } = response;

        if (status === 'success') {
          $form.find('.form-group.on-focus').each(function(index, item) {
            $(item).removeClass('on-focus');
          });
          form.reset();
        }

        responseBox.html(message).fadeIn();
      })
      .fail(function(error) {
        console.warn(error);
      })
      .always(function() {
        loader.removeClass('is-active');
        submitButton.removeClass('disabled');
        submitButton.prop('disabled', false);

        setTimeout(function() {
          responseBox.fadeOut(function() {
            responseBox.empty();
          });
        }, 5000);
      });

    });
  });

  $(window).scroll(function() {
    let offset = isMobile ? 60 : 100;

    if ($(this).scrollTop() + offset > $('.main-content').height()) {
      $('body').addClass('light-theme');
    } else {
      $('body').removeClass('light-theme');
    }

    if (isMobile() && ($(this).scrollTop() > ($('.main-content').height() - $(window).height()))) {
      $('.fixed-links').fadeOut();
    } else {
      $('.fixed-links').fadeIn();
    }
  });

  $(window).on('load', function () {
    setTimeout(function() {
      $('body').addClass('page-loaded');
      $('body').css('overflow-y', 'auto')
    }, 600);
  });

})(jQuery);
